<template>
  <v-layout
		fluid
		pt-4
		mt-5
		pl-1
		pr-1>
    <v-flex xs4>
      <panel title="User Information">
        <v-text-field
          :rules="[required]"
          v-model="newuser.name"
          label="Name"
          required
        />
        <v-text-field
          v-model="newuser.role"
          label="Role"
					required
        />
        <v-text-field
          v-model="newuser.phone"
          label="Phone"
        />
        <v-text-field
          v-model="newuser.email"
          label="E-Mail Address"
					required
        />

      <div
        v-if="error"
        class="danger-alert"
      >
        {{ error }}
      </div>
      <v-btn
        :color="strongColor"
				dark
        @click="save"
      >
        Save User
      </v-btn>
       <v-btn
			  :color="strongColor"
        dark
        @click="remove">
        Delete User
      </v-btn>
			      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import UsersService from '@/services/UsersService'
import { STRONG_COLOR } from "@/components/globals/consts.js";
import {mapState} from 'vuex'

export default {
	data () {
		return {
			newuser: {
				name: null,
				role: null,
				phone: null,
				email: null // user login
			},
			error: null,
			required: (value) => !!value || 'Required.',
			strongColor: STRONG_COLOR
		}
	},
	computed: {
		...mapState([
			'isUserLoggedIn',
			'user',
			'route'
		])
	},
	async created () {
		try {
		if (!this.isUserLoggedIn) {
			this.$router.push({
				name: 'login'
			})
		}
		if (this.user.role === 'Master') {
			this.$router.push({
				name: 'clients'
			})
		}
	
		const userId = this.$store.state.route.params.userId
		this.newuser = (await UsersService.show(userId)).data
		} catch (err) {
			console.log(err)
		}
	},
	methods: {
		async remove () {
			try {
			this.error = null
			const userId = this.$store.state.route.params.userId
			
				if (this.$store.state.user.role === 'Master') {
					this.$router.push({
						name: 'clients'
					})
				} else if (this.$store.state.user.role === 'Admin') {
					await UsersService.delete(userId)
					this.$router.push({
						name: 'users'
					})
				}
			} catch (err) {
				console.log(err)
			}
		},
		async save () {
			this.error = null
			const userId = this.$store.state.route.params.userId
			try {
				if (this.$store.state.user.role === 'Master') {
					this.$router.push({
						name: 'clients'
					})
				} else if (this.$store.state.user.role === 'Admin') {
					await UsersService.put(this.newuser)
					this.$router.push({
						name: 'users',
						params: {
							userId: userId
						}
					})
				}
			} catch (err) {
				console.log(err)
			}
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EditUser.vue